export default function ArticleCTA() {
  return (
    <section className="relative overflow-hidden">
      <div className="flex flex-col lg:flex-row">
        <div className="relative w-full lg:w-1/2 h-[280px] lg:h-[420px] overflow-hidden bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20still%20life%20of%20luxury%20shopping%20bag%20with%20tissue%20paper%20next%20to%20designer%20shoe%20box%20on%20polished%20concrete%20floor%2C%20side%20natural%20light%2C%20clean%20editorial%20style%2C%20shopping%20concept%2C%20no%20text&width=900&height=630&seq=artcta-v3-left&orientation=landscape"
            alt="Acesse o Hoobuy Spreadsheet"
            title="Hoobuy Spreadsheet - Acesse Agora"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
          <div className="absolute bottom-6 left-6">
            <h2 className="text-2xl md:text-3xl font-bold text-white">
              Não Perca Tempo
            </h2>
          </div>
        </div>

        <div className="w-full lg:w-1/2 flex items-center justify-center bg-background-50 py-12 md:py-16 px-8">
          <div className="max-w-[440px] text-center">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              ACESSE O HOOBUY SPREADSHEET
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              Mais de 5.000 links verificados e atualizados diariamente para compradores do Brasil. Economize horas de pesquisa.
            </p>
            <div className="mt-7">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-3 px-10 py-4 bg-foreground-950 text-background-50 font-bold text-base rounded-full whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-all duration-300"
              >
                hoobuy sheet
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}